"use strict";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var React = require('react');

var PropTypes = require('prop-types');

var moment = require('moment');

var ProductDetailsWrapper = require('../components/ProductDetailsWrapper');

var Space = require('../components/Space');

var HorizontalLine = require('../components/HorizontalLine');

var PrintJobPaperTypes = require('../components/PrintJobPaperTypes');

var EstimatedPricing = require('../components/EstimatedPricing');

var CustomerShippingAddress = require('../components/CustomerShippingAddress');

var PrintJobColorsUsed = require('../components/PrintJobColorsUsed');

var PrintJobDesignNames = require('../components/PrintJobDesignNames');

var PaperComponentDetails = require('../components/PaperComponentDetails');

var Highlight = require('../components/Highlight');

var _require = require('../../helpers'),
    isEnvelope = _require.isEnvelope,
    isShipment = _require.isShipment,
    isLetterpressComponent = _require.isLetterpressComponent;

var letterpressPaperComponents = function letterpressPaperComponents(c) {
  return isLetterpressComponent(c) && !isEnvelope(c);
};

function SampleSets(props) {
  var PrintJobs = props.PrintJobs,
      Shipments = props.Shipments,
      user = props.user,
      options = props.options;

  if (PrintJobs.length > 1) {
    throw new Error('SampleSets template is meant for 1 print job');
  }

  var printJob = PrintJobs[0];
  var shipment = Shipments[0];
  var printer = 'printingPlus';
  var componentSettings = options.printers[printer].components;

  if (!componentSettings) {
    throw new Error('componentSettings were undefined');
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Highlight, null, "*************** DO NOT SHRINK ***************"), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement(PrintJobPaperTypes, {
    variant: "letterpress",
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement("span", null, "Sent by: ", user.displayName), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), isShipment(shipment) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Customer Shipping Address:", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(CustomerShippingAddress, {
    shipment: shipment
  }), /*#__PURE__*/React.createElement(Space, {
    n: 2
  })), /*#__PURE__*/React.createElement("span", null, "Ship by Date: ", moment(printJob.print_by_date).format('ddd MMM DD YYYY')), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), isShipment(shipment) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Shipping Service: ", shipment.service), /*#__PURE__*/React.createElement(Space, {
    n: 2
  })), /*#__PURE__*/React.createElement(PrintJobPaperTypes, {
    variant: "letterpress",
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(PrintJobColorsUsed, {
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(PrintJobDesignNames, {
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), !printJob.is_reprint && /*#__PURE__*/React.createElement(React.Fragment, null, printJob.notes.map(function (_ref, index) {
    var text = _ref.text;
    return /*#__PURE__*/React.createElement(Highlight, {
      key: index
    }, "Printer Note: ", text, /*#__PURE__*/React.createElement("br", null));
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
    printJob: printJob,
    filterFunction: letterpressPaperComponents,
    RenderComponent: PaperComponentDetails,
    options: options,
    componentSettings: componentSettings,
    printer: printer
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(HorizontalLine, null)), /*#__PURE__*/React.createElement("span", null, "Estimated Pricing"), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement(EstimatedPricing, _extends({}, props, {
    printer: printer,
    variant: "SampleSets",
    printJob: printJob
  })), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement(HorizontalLine, null), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(Highlight, null, "*************** DO NOT SHRINK ***************"), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }));
}

SampleSets.defaultProps = {};
SampleSets.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  Shipments: PropTypes.array.isRequired,
  user: PropTypes.shape({
    displayName: PropTypes.string.isRequired
  }).isRequired,
  options: PropTypes.object
};
module.exports = SampleSets;